// // src/components/Settings/SettingsModal.tsx
// import React, { useState, useEffect } from 'react';
// import { X, Building2, Briefcase, MapPin, Building, Settings as SettingsIcon, Database, Home, User, Headphones, CreditCard, UserCircle } from 'lucide-react';
// import AddCompany from '../AddCompany';
// import AddOffice from '../AddOffice';
// import { StartupKhataSettings } from '../../components/Setting';
// import { SettingsTab } from '../../components/SettingsDropdown';

// interface SettingsModalProps {
//   isOpen: boolean;
//   onClose: () => void;
//   defaultTab?: SettingsTab;
// }

// interface SettingsItem {
//   id: SettingsTab;
//   label: string;
//   icon: React.ReactNode;
//   description: string;
// }

// export function SettingsModal({ isOpen, onClose, defaultTab = 'company' }: SettingsModalProps) {
//   const [activeTab, setActiveTab] = useState<SettingsTab>(defaultTab);

//   useEffect(() => {
//     if (isOpen && defaultTab) {
//       setActiveTab(defaultTab);
//     }
//   }, [isOpen, defaultTab]);

//   const settingsItems: SettingsItem[] = [
//     // {
//     //   id: 'home',
//     //   label: 'Home',
//     //   icon: <Home className="w-5 h-5" />,
//     //   description: 'Go to dashboard home'
//     // },
//     // {
//     //   id: 'profile',
//     //   label: 'Profile',
//     //   icon: <User className="w-5 h-5" />,
//     //   description: 'Manage your profile information'
//     // },
//     // {
//     //   id: 'branches',
//     //   label: 'Branches',
//     //   icon: <Building2 className="w-5 h-5" />,
//     //   description: 'Manage organization branches'
//     // },
    // {
    //   id: 'company',
    //   label: 'Company Settings',
    //   icon: <Briefcase className="w-5 h-5" />,
    //   description: 'Manage company information, details, and configurations'
    // },
//     {
//       id: 'office',
//       label: 'Office Settings',
//       icon: <MapPin className="w-5 h-5" />,
//       description: 'Configure office locations, addresses, and contact details'
//     },
//     {
//       id: 'department',
//       label: 'Department Settings',
//       icon: <Building2 className="w-5 h-5" />,
//       description: 'Create and manage departments within your organization'
//     },
//     {
//       id: 'designation',
//       label: 'Designation Settings',
//       icon: <UserCircle className="w-5 h-5" />,
//       description: 'Define job titles, roles, and designations'
//     },
//     {
//       id: 'startupkhata',
//       label: 'Startup Khata Settings',
//       icon: <Database className="w-5 h-5" />,
//       description: 'Configure Startup Khata integration and synchronization'
//     },
//     // {
//     //   id: 'contact',
//     //   label: 'Contact Us',
//     //   icon: <Headphones className="w-5 h-5" />,
//     //   description: 'Get support or contact our team'
//     // },
//     // {
//     //   id: 'upgrade',
//     //   label: 'Upgrade Plan',
//     //   icon: <CreditCard className="w-5 h-5" />,
//     //   description: 'Upgrade your subscription plan'
//     // }
//   ];

//   const renderContent = () => {
//     switch (activeTab) {
//       case 'company':
//         return <AddCompany />;
//       case 'office':
//         return <AddOffice />;
//       case 'startupkhata':
//         return <StartupKhataSettings onSave={() => {
//           console.log('Startup Khata settings saved');
//         }} />;
//       // case 'home':
//       //   return <HomePagePlaceholder />;
//       case 'profile':
//         return <ProfilePlaceholder />;
//       case 'branches':
//         return <BranchesPlaceholder />;
//       case 'department':
//         return <DepartmentPlaceholder />;
//       case 'designation':
//         return <DesignationPlaceholder />;
//       // case 'contact':
//       //   return <ContactPlaceholder />;
//       // case 'upgrade':
//       //   return <UpgradePlaceholder />;
//       default:
//         return <div className="p-6 text-center text-gray-500">Coming soon...</div>;
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       {/* Backdrop */}
//       <div 
//         className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300"
//         onClick={onClose}
//       />

//       {/* Modal */}
//       <div className="fixed inset-0 z-50 overflow-y-auto">
//         <div className="flex min-h-full items-center justify-center p-4">
//           <div 
//             className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300 flex flex-col"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className="sticky top-0 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-800 border-b border-gray-200 dark:border-gray-700 px-6 py-4">
//               <div className="flex justify-between items-center">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
//                     <SettingsIcon className="w-5 h-5 text-white" />
//                   </div>
//                   <div>
//                     <h2 className="text-xl font-bold text-gray-900 dark:text-white">
//                       {settingsItems.find(item => item.id === activeTab)?.label || 'Settings'}
//                     </h2>
//                     <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
//                       {settingsItems.find(item => item.id === activeTab)?.description || 'Manage your preferences'}
//                     </p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={onClose}
//                   className="p-2 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors"
//                 >
//                   <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
//                 </button>
//               </div>
//             </div>

//             {/* Content */}
//             <div className="flex flex-1 overflow-hidden">
//               {/* Sidebar Navigation */}
//               <div className="w-72 border-r border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 overflow-y-auto">
//                 <div className="p-4 space-y-2">
//                   {settingsItems.map((item) => (
//                     <button
//                       key={item.id}
//                       onClick={() => setActiveTab(item.id)}
//                       className={`
//                         w-full flex items-start gap-3 p-3 rounded-lg transition-all duration-200 text-left
//                         ${activeTab === item.id 
//                           ? 'bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 border-l-4 border-blue-500' 
//                           : 'hover:bg-gray-100 dark:hover:bg-gray-800'
//                         }
//                       `}
//                     >
//                       <div className={`
//                         p-2 rounded-lg transition-colors
//                         ${activeTab === item.id 
//                           ? 'text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30' 
//                           : 'text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800'
//                         }
//                       `}>
//                         {item.icon}
//                       </div>
//                       <div className="flex-1">
//                         <h3 className={`
//                           text-sm font-semibold mb-1
//                           ${activeTab === item.id 
//                             ? 'text-blue-700 dark:text-blue-400' 
//                             : 'text-gray-700 dark:text-gray-300'
//                           }
//                         `}>
//                           {item.label}
//                         </h3>
//                         <p className="text-xs text-gray-500 dark:text-gray-400">
//                           {item.description}
//                         </p>
//                       </div>
//                       {activeTab === item.id && (
//                         <div className="w-1.5 h-1.5 rounded-full bg-blue-500 mt-2"></div>
//                       )}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               {/* Content Area */}
//               <div className="flex-1 overflow-y-auto">
//                 {renderContent()}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes zoomIn {
//           from { transform: scale(0.95); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//         .animate-in {
//           animation-duration: 0.2s;
//           animation-fill-mode: both;
//         }
//         .fade-in {
//           animation-name: fadeIn;
//         }
//         .zoom-in {
//           animation-name: zoomIn;
//         }
//       `}</style>
//     </>
//   );
// }

// // Placeholder components for other settings
// function HomePagePlaceholder() {
//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-bold text-gray-900 mb-4">Home</h2>
//       <p className="text-gray-600">Dashboard home content will appear here.</p>
//     </div>
//   );
// }

// function ProfilePlaceholder() {
//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-bold text-gray-900 mb-4">Profile Settings</h2>
//       <p className="text-gray-600">Profile management will appear here.</p>
//     </div>
//   );
// }

// function BranchesPlaceholder() {
//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-bold text-gray-900 mb-4">Branches</h2>
//       <p className="text-gray-600">Branch management will appear here.</p>
//     </div>
//   );
// }

// function DepartmentPlaceholder() {
//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-bold text-gray-900 mb-4">Department Settings</h2>
//       <p className="text-gray-600">Department management will appear here.</p>
//     </div>
//   );
// }

// function DesignationPlaceholder() {
//   return (
//     <div className="p-6">
//       <h2 className="text-2xl font-bold text-gray-900 mb-4">Designation Settings</h2>
//       <p className="text-gray-600">Designation management will appear here.</p>
//     </div>
//   );
// }

// // function ContactPlaceholder() {
// //   return (
// //     <div className="p-6">
// //       <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
// //       <p className="text-gray-600">Contact information and support will appear here.</p>
// //     </div>
// //   );
// // }

// // function UpgradePlaceholder() {
// //   return (
// //     <div className="p-6">
// //       <h2 className="text-2xl font-bold text-gray-900 mb-4">Upgrade Plan</h2>
// //       <p className="text-gray-600">Subscription plans and upgrade options will appear here.</p>
// //     </div>
// //   );
// // }

import { useParams } from 'react-router-dom';
import AddCompany from '../../pages/AddCompany';
import AddOffice from '../../pages/AddOffice';
import {DepartmentManagement} from '../../pages/DepartmentManagement';
import {DesignationManagement} from '../../pages/DesignationManagement';
import { StartupKhataSettings } from '../../components/Setting';
import { TermsConditions } from '../Termscondition';

export default function SettingsPage() {
  const { tab } = useParams();

  const renderContent = () => {
    switch (tab) {
      case 'company':
        return <AddCompany />;
      case 'office':
        return <AddOffice />;
      case 'department':
        return <DepartmentManagement/>;
      case 'designation':
        return <DesignationManagement/>;
      case 'terms-and-conditions':
        return <TermsConditions />;
      case 'startupkhata':
        return <StartupKhataSettings onSave={() => {}} />;
      default:
        return <div>Select a setting</div>;
    }
  };

  return (
    <div className="p-6">
      {/* <h1 className="text-xl font-bold mb-4 capitalize">
        {tab} Settings
      </h1> */}

      {renderContent()}
    </div>
  );
}